import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        needRefresh: false, // 页面是否需要刷新
        // 刷新购物车
        refreshShopCar: '',
        // 随机数更新未读消息的数量
        messageNum: '',
        // 当前处于激活状态的nav索引
        navLv1: '1',
        navLv2: '1',
        navLv3: '1',
        sp1Form: {}, //注册第一步的表单数据
        askPJMsg: {}, // 询问配件信息
        askOrderMsg: {}, // 询问订单信息
        askGoods: {}, // 询问商品信息
        askShareGoods: {}, // 询问共享商品信息
        connectState: 0, // socket连接状态 0 未连接 1 需要连接 2连接成功 5连接失败
        serviceMsg: {}, // 当前连到的客服信息
        groupMsg: {}, //企业好友群消息
        reflashUnion: false, //需要重新获取联盟权限
        showPreOrder: 0, //展示待售侧边条
        updateEditOrder: 0, //更新开单页的商品明细
        cancelTokenArr: [],
        orderData: {
            Id: '',
            IsAdd: false,
            Refresh:false,//重置查询参数查询第一页数据
        }
    },
    getters: {
        orderData: state => {
            return state.orderData;
        },
        needRefresh: state => {
            return state.needRefresh;
        },
        refreshShopCar: state => {
            return state.refreshShopCar;
        },
        askPJMsg: state => {
            return state.askPJMsg;
        },
        askGoods: state => {
            return state.askGoods;
        },
        askShareGoods: state => {
            return state.askShareGoods;
        },
        askOrderMsg: state => {
            return state.askOrderMsg;
        },
        getConnectState: state => {
            return state.connectState;
        },
        getGroupMsg: state => {
            return state.groupMsg;
        },
        getNewUnionPer: state => {
            return state.reflashUnion;
        },
        getShowPreOrder: state => {
            return state.showPreOrder;
        },
        getEditOrderStat: state => {
            return state.updateEditOrder;
        }
    },
    mutations: {
        updateOrderList(state, params) {
            state.orderData = params;
        },
        updateNeedRefresh(state, params) {
            state.needRefresh = params;
        },
        updateNeedRefresh_autoPur(state, params) {
            state.needRefresh_autoPur = params;
        },
        updateServiceMsg(state, params) {
            state.serviceMsg = params;
        },
        updateRefreshShopCar(state, params) {
            state.refreshShopCar = params;
        },
        updateAskOrder(state, params) {
            state.askOrderMsg = params;
        },
        updateMessageNum(state, params) {
            state.messageNum = String(params);
        },
        updateNav(state, params) {
            state.navLv1 = String(params.n1);
            state.navLv2 = String(params.n2);
            state.navLv3 = String(params.n3);
        },
        updateSp1Form(state, params) {
            state.sp1Form = params;
        },
        // 询问配件信息
        updateAskPJMsg(state, params) {
            state.askPJMsg = params;
        },
        // 询问商品信息
        updateAskGoods(state, params) {
            state.askGoods = params;
        },
        // 询问共享商品信息
        updateAskShareGoods(state, params) {
            state.askShareGoods = params;
        },
        // socket连接状态
        updateConnectState(state, params) {
            state.connectState = params;
        },
        updateGroupMsg(state, params) {
            state.groupMsg = params;
        },
        updateReflashUnion(state, params) {
            state.reflashUnion = params;
        },
        updateShowPreOrder(state, params) {
            state.showPreOrder = params;
        },
        updateEditOrder(state, params) {
            state.updateEditOrder = params;
        },
        //添加请求
        addCancelToken(state, cancel) {
            if (!state.cancelTokenArr) {
                state.cancelTokenArr = [];
            }
            if (cancel) {
                state.cancelTokenArr.push(cancel);
            }
        },
        // 取消所有请求
        clearCancelToken(state) {
            state.cancelTokenArr.forEach(c => {
                if (c) {
                    c();
                }
            });
            state.cancelTokenArr = [];
        }
    },
    actions: {}
});
